import { Box, styled } from '@mui/material';

export const StyledCardActionsButtons = styled(Box, {
  // не передавать этот проп на DOM
  shouldForwardProp: (prop) => prop !== 'isOnlyRightSlot',
})<{ isOnlyRightSlot: boolean }>(({ isOnlyRightSlot }) => ({
  width: '100%',
  padding: '24px',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: isOnlyRightSlot ? 'flex-end' : 'space-between',
}));

export const StyledActions = styled(Box)({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
});
